import PageWrapper from "../../components/common/PageWrapper";
import Header from "../../components/common/Header";
import BodyWrapper from "../../components/common/BodyWrapper";
import Footer from "../../components/common/Footer";
import Wrapper from "../../components/dashboard/dashboardPartials/Wrapper";
import MySubscriptions from "../../components/dashboard/dashboardPartials/MySubscriptions";
import MyOrders from "../../components/dashboard/dashboardPartials/MyOrders";
import AllProfileOptions from "../../components/dashboard/profilePartials/AllProfileOptions";
import EditPersonalInfo from "../../components/dashboard/profilePartials/EditPersonalInfo";
import EditChildInfo from "../../components/dashboard/profilePartials/EditChildInfo";
import { useGeneral } from "../../components/contexts/GeneralContext";
import { useEffect, useState } from "react";
import axios from "../../config/axios";
import ApiErrorMessage from "../../components/common/ApiErrorMessage";
import NoItemsFound from "../../components/common/NoItemsFound";
import ChildListing from "../../components/dashboard/profilePartials/ChildListing";
import { useParams } from "react-router-dom";
import AddChildInfo from "../../components/dashboard/profilePartials/AddChildInfo";
const usePageContent = () => {
  const { discountCoupons } = useGeneral();

  return { discountCoupons };
};

const useScrollToTop = () => {
  useEffect(() => {
    const timer = setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 100);
    return () => clearTimeout(timer);
  }, []);
};
const AddChildInfoPage = () => {
  const { discountCoupons } = usePageContent();
  useScrollToTop();

  return (
    <>
      {/* <FullScreenLoading /> */}
      <PageWrapper loading={false} className="bg-bg min-h-screen">
        <Header code={discountCoupons} />

        <BodyWrapper className="mb-0 xl:mb-0">
          <Wrapper goBack={true} component={<AddChildInfo />} />
        </BodyWrapper>
        <Footer />
      </PageWrapper>
    </>
  );
};

export default AddChildInfoPage;
